<template>
  <div class="dashboard-container">
	  <div style="color: #3e3e3e;font-size: 18px;margin-bottom: 15px;">用户管理>用户列表>用户数据-用户列表</div>
      <el-tabs v-model="activeName" class="tas" type="card" @tab-click="handleClick">
        <el-tab-pane label="用户信息" name="first">
          <Hair ></Hair>
        </el-tab-pane>
<!--        <el-tab-pane label="剪发服务订单" name="two">
          <Hair2 ></Hair2>
        </el-tab-pane>
        <el-tab-pane label="商城兑换订单" name="three">
          <num3></num3>
        </el-tab-pane>
        <el-tab-pane label="评价" name="four">
          <Hair4 ></Hair4>
        </el-tab-pane> -->
      </el-tabs>
  </div>
</template>
<script>
import Hair from "./udatalists/udatalists1.vue"
import Hair2 from "./udatalists/udatalists2.vue"
import num3 from "./udatalists/udatalists3.vue"
import Hair4 from "./udatalists/udatalists4.vue"
export default {
	components:{
		Hair,Hair2,num3,Hair4
	},
  data() {
    return {
      activeName: 'first',
    }
  },
  mounted() {
    
  },
  methods: {
    handleClick(tab, event) {
		// console.log(this.activeName)
    }
  }
}
</script>

